<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-border ts-p-3 ts-rounded ts-overflow-y-scroll max-h">
        <table class="ts-w-full">
          <thead>
            <tr>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                "
              >
                {{ $t('stockCount.barcode') }}
              </th>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                "
              >
                {{ $t('stockCount.productName') }}
              </th>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                "
              >
                {{ $t('stockCount.uom') }}
              </th>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                "
              >
                {{ $t('stockCount.cust') }}
              </th>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                "
              >
                {{ $t('stockCount.price') }}
              </th>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                "
              >
                {{ $t('stockCount.sysQty') }}
              </th>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                "
              >
                {{ $t('stockCount.countQty') }}
              </th>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                  ts-w-5
                "
              >
                {{ $t('stockCount.difference') }}
              </th>
              <th
                class="
                  ts-uppercase
                  ts-bg-gray-200
                  ts-whitespace-no-wrap
                  ts-py-2
                  ts-px-2
                "
              >
                {{ $t('stockCount.remark') }}
              </th>
            </tr>
            <!-- <tr>
								<th colspan="8" class="ts-py-2 ts-px-2">
									<input type="text" placeholder="Search" class="form-control">
								</th>
							</tr> -->
          </thead>
          <tbody>
            <tr v-for="(item, index) in productDetails" :key="index">
              <td valign="top" class="ts-p-2 ts-w-48">
                <input
                  :value="getLabelDisplay(item.product_id).barcode"
                  type="text"
                  class="form-control"
                  readonly
                />
              </td>
              <td valign="top" class="ts-p-2">
                <input
                  :value="getLabelDisplay(item.product_id).product_name_en"
                  type="text"
                  class="form-control"
                  readonly
                />
              </td>
              <td valign="top" class="ts-p-2 ts-w-32">
                <input
                  :value="
                    getLabelDisplay(item.product_id).sale_code[0].uom_name_en
                  "
                  type="text"
                  class="form-control"
                  readonly
                />
              </td>
              <td valign="top" class="ts-p-2 ts-w-32">
                <input
                  v-model="item.cost"
                  readonly
                  type="number"
                  class="form-control"
                />
              </td>
              <td valign="top" class="ts-p-2 ts-w-32">
                <input
                  v-model="item.price"
                  readonly
                  type="number"
                  class="form-control"
                />
              </td>
              <td valign="top" class="ts-p-2 ts-w-32">
                <input
                  v-model.number="item.system_qty"
                  readonly
                  type="number"
                  class="form-control"
                />
              </td>
              <td valign="top" class="ts-p-2 ts-w-32">
                <input
                  :tabindex="6 * index + 1"
                  @keypress.enter="onCountQtyEnter(index)"
                  v-model.number="item.count_qty"
                  @input="calculate"
                  ref="countQty"
                  type="number"
                  class="form-control"
                />
                <div
                  class="validate"
                  v-if="errors.has('product_detail.' + index + '.count_qty')"
                >
                  {{ errors.first('product_detail.' + index + '.count_qty') }}
                </div>
              </td>
              <td>
                <input
                  type="text"
                  class="form-control text-center"
                  readonly
                  :value="item.count_qty - item.system_qty"
                />
              </td>
              <td valign="top" class="ts-p-2 ts-w-64">
                <input
                  :tabindex="6 * index + 2"
                  @keypress.tab="onReasonTab(index)"
                  v-model="item.reason"
                  ref="reason"
                  type="text"
                  class="form-control"
                />
                <div
                  class="validate"
                  v-if="errors.has('product_detail.' + index + '.reason')"
                >
                  {{ errors.first('product_detail.' + index + '.reason') }}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
export default {
  name: 'stockCountItemDetails',
  props: ['value', 'validate'],
  data() {
    return {
      loading: false,
      errors: new Errors(),
      search: '',
      model: {},
      row: {
        product_id: null,
        uom_id: null,
        cost: null,
        price: null,
        system_qty: null,
        count_qty: null,
        reason: null,
      },
    }
  },
  async created() {
    this.model = this.value
    this.loading = true
    await this.fetchResource().finally(() => (this.loading = false))
    if (this.$route.params.id) {
      await this.find(this.$route.params.id)
    }
    await this.createData()
  },
  computed: {
    ...mapState('stock/stockCount', ['products', 'edit_data']),
    getLabelDisplay: (vm) => (productId) => {
      return vm.products.find((p) => p.product_id == productId)
    },
    productDetails() {
      return this.model.product_detail
    },
  },
  methods: {
    ...mapActions('stock/stockCount', ['fetchResource', 'find']),
    createData() {
      this.model.product_detail = []
      if (_.isEmpty(this.edit_data)) {
        this.products.forEach((el) => {
          this.model.product_detail.push({
            product_id: el.product_id,
            barcode: el.barcode,
            product_name_en: el.product_name_en,
            uom_id: el.sale_code[0].uom_id,
            cost: el.sale_code[0].product_price
              ? el.sale_code[0].product_price.cost
              : 0,
            price: el.sale_code[0].product_price
              ? el.sale_code[0].product_price.sale_price
              : 0,
            system_qty: el.sale_code[0].ending_balance,
            count_qty: null,
            reason: null,
          })
        })
        this.calculate()
      } else {
        this.edit_data
        this.model.count_date = this.edit_data.count_date
        this.model.total_amount = this.edit_data.total_amount
        this.model.remarks = this.edit_data.remarks
        this.edit_data.details.forEach((el) => {
          this.model.product_detail.push({
            product_id: el.product_id,
            barcode: el.barcode,
            product_name_en: el.product_name_en,
            uom_id: el.uom_id,
            cost: el.cost,
            price: el.price,
            system_qty: el.system_qty,
            count_qty: el.count_qty,
            reason: el.reason,
          })
        })
      }
      this.calculate()
    },
    calculate() {
      this.model.total_amount = _.round(
        _.sumBy(this.model.product_detail, (o) => {
          return o.price * o.count_qty
        }),
        2
      )
    },
    onCountQtyEnter(index) {
      if (index + 1 < this.model.product_detail.length) {
        this.$refs.countQty[index + 1].focus()
      } else {
        this.$refs.countQty[0].focus()
      }
      // this.$refs.reason[index].focus()
    },
    onReasonTab(index) {
      this.$refs.countQty[index + 1].focus()
    },
    async productSearch(search) {
      this.loading = true
      await this.createData()
      this.model.product_detail = this.model.product_detail
        .filter((c) =>
          search
            .split(' ')
            .every(
              (s) =>
                c.barcode.toLowerCase().includes(s.toLowerCase()) ||
                c.product_name_en.toLowerCase().includes(s.toLowerCase())
            )
        )
        .slice(0, 400)
      this.loading = false
    },
  },
  watch: {
    validate: function (error) {
      this.errors = new Errors(error.errors)
    },
  },
}
</script>

<style scoped>
.max-h {
  min-height: 30vh;
  max-height: 70vh;
}
table {
  position: relative;
  border-collapse: collapse;
}
th {
  z-index: 9999;
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  /* box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4); */
}
</style>
